import Banner from '../../components/landing/Banner'
import HorizontalContentCard from '../../components/HorizontalContentCard'
import SolutionsLayout from '../../layouts/Solutions'
import { ContactUs } from '../../components/solutions/ContactUs'
import { MachineLearningSolutionPageContent } from '../../data/MachineLearningSolutionPageContent'

// Next js Components
import Head from 'next/head'

export const getStaticPaths = () => {
    const paths = []
    for (const slug in MachineLearningSolutionPageContent) {
        paths.push({ params: { slug } })
    }

    return {
        paths,
        fallback: false,
    }
}

export const getStaticProps = ({ params }) => {
    const slug = params.slug
    const data = MachineLearningSolutionPageContent[slug]

    if (!data) {
        return {
            notFound: true,
        }
    }

    return {
        props: { data },
    }
}

const MachineLearningSolutionsPage = ({ data }) => {
    return (
        <>
            <Head>
                <title>
                    {data?.meta?.title} | {process.env.NEXT_PUBLIC_APP_NAME}
                </title>
                <meta name="description" content={data?.meta.description} />
                <meta
                    property="og:title"
                    content={`${data?.meta?.title} | ${process.env.NEXT_PUBLIC_APP_NAME}`}
                />
                <meta
                    property="og:description"
                    content={data?.meta.description}
                />
                <meta property="og:image" content={data?.meta.ogImage} />
                <meta
                    property="og:url"
                    content={`${process.env.NEXT_PUBLIC_APP_URL}${data?.meta?.ogURL}`}
                />
                <meta
                    name="twitter:title"
                    content={`${data?.meta?.title}  | ${process.env.NEXT_PUBLIC_APP_NAME}`}
                />
                <meta
                    name="twitter:description"
                    content={data?.meta.description}
                />
                <meta
                    name="twitter:image"
                    content={`${process.env.NEXT_PUBLIC_APP_URL}${data?.meta.ogImage}`}
                />
            </Head>
            <div>
                <Banner
                    title={data?.banner?.title}
                    description={data?.banner?.description}
                    videoUrl={data?.banner?.videoUrl}
                    coverImage={data?.banner?.coverImage}
                />
                <div className="container">
                    <div
                        className="section"
                        itemScope
                        itemType="https://schema.org/WebPage"
                    >
                        <div>
                            <h2 className="heading" itemProp="headline">
                                {data?.section?.heading}
                            </h2>
                            <p className="description" itemProp="description">
                                {data?.section?.description}
                            </p>
                        </div>
                        <div className="grid grid-cols-2 tablet:grid-cols-1  gap-8 mb-[42px]">
                            {data?.cardData?.map((item) => (
                                <HorizontalContentCard
                                    key={item.id}
                                    cardDetails={item}
                                />
                            ))}
                        </div>
                        <ContactUs />
                    </div>
                </div>
            </div>
        </>
    )
}

MachineLearningSolutionsPage.getLayout = SolutionsLayout
export default MachineLearningSolutionsPage
